import styled from 'styled-components';


export const WelcomeCarousel = styled.div`
	& > .carousel-root {
		& > .carousel-slider {
			position: relative !important;
			padding-bottom: 20px;
			margin-left: 7px !important;
			margin-top: 20px;
			& > .control-dots {
				display: flex;
             &>.slide{
				min-width: 94%;
			 }
				& > .dot {
					opacity: 1;
					box-shadow: none;
					margin: 0px 3px !important;
					width: 6px !important;
					height: 6px !important;
					background: #ffffff;
					border: 1px solid
						${(props) => {
							return props.data.colorMode === 'dark'
								? 'var(--selectedColor)'
								: props.data.colorScale[0];
						}};
					&.selected {
						background: ${(props) =>
							props.data.colorMode === 'dark'
								? 'var(--selectedColor)'
								: props.data.colorScale[0]} !important;
					}
				}
			}
			& > .slider-wrapper {
				& > .slider {
					gap: 8px;
					left: unset !important;
					& > li {
						& > div > img {
							border-radius: 20px;
                             width:320px;
							 height:180px;
						
							object-fit: cover;
						}
					}
				}
			}
		}
	}
`;

export const GETINTOUCHDIV = styled.div<{
	fontSize: string;
	colorScale: string[];
}>``;

export const FooterHolder = styled.div`
	&.welcome-footer {
		display: none;
		justify-content: space-between;
		flex-direction: row;
		z-index: 999;

		& > div {
			cursor: pointer;
			display: flex;
			flex-direction: column;
			align-items: center;
			width: 50%;

			& > .ff-chatbot-caption {
				margin: 0;
				margin-top: 4px;
			}
			&:not(.selected) {
				opacity: 0.6;
			}
		}
	}
`;
